/* @flow */
import Entity from 'lib/Entity';

export default class Avatar extends Entity {
  getColor() {
    return this.get('color');
  }

  getUrl() {
    // file_url is a PNG version which we don't use on web anymore.
    return this.get('svg_url');
  }
}



// WEBPACK FOOTER //
// ./src/entities/Avatar.js